import { RECEIVE_DATA_OBJECTS, REMOVE_DATA_OBJECTS, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { allianceDetailsManager, type IAlliance } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

export const DRAFT_ALLIANCE = 'setStatusDraft';
export const ACTIVE_ALLIANCE = 'setStatusActive';
export const TERMINATED_ALLIANCE = 'setStatusTerminated';
export const ABORTED_ALLIANCE = 'setStatusAborted';
export const MAKE_PUBLIC = 'makePublic';
export const MAKE_PRIVATE = 'makePrivate';
export const REMOVE_FROM_STORE = 'removeFromStore';

export const actions: ActionTree<IAlliance, unknown> = {
    async [DRAFT_ALLIANCE](context, { allianceDetailId, properties }: { allianceDetailId: number; properties?: string }) {
        const result = await allianceDetailsManager.changeStatusToDraft(allianceDetailId, { properties });
        void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [result] });
    },
    async [ACTIVE_ALLIANCE](context, { allianceDetailId, properties }: { allianceDetailId: number; properties?: string }) {
        const result = await allianceDetailsManager.changeStatusToActive(allianceDetailId, { properties });
        void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [result] });
    },
    async [TERMINATED_ALLIANCE](context, { allianceDetailId, properties }: { allianceDetailId: number; properties?: string }) {
        const result = await allianceDetailsManager.changeStatusToTerminated(allianceDetailId, { properties });
        void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [result] });
    },
    async [ABORTED_ALLIANCE](context, { allianceDetailId, properties }: { allianceDetailId: number; properties?: string }) {
        const result = await allianceDetailsManager.changeStatusToAborted(allianceDetailId, { properties });
        void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [result] });
    },
    async [MAKE_PUBLIC](context, { allianceDetailId, properties }: { allianceDetailId: number; properties?: string }) {
        const result = await allianceDetailsManager.makeAllianceDetailPublic(allianceDetailId, { properties });
        if (result !== undefined) {
            context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: [result] });
        }
    },
    async [MAKE_PRIVATE](context, { allianceDetailId, properties }: { allianceDetailId: number; properties?: string }) {
        const result = await allianceDetailsManager.makeAllianceDetailPrivate(allianceDetailId, { properties });
        if (result !== undefined) {
            context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: [result] });
        }
    },
    [REMOVE_FROM_STORE](context, { allianceDetailId }: { allianceDetailId: number }) {
        context.commit(REMOVE_DATA_OBJECTS, { dobjId: allianceDetailId });
    }
};
